import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AccountService } from './account.service';
import { AppState } from '@store/reducers';
import { Store } from '@ngrx/store';
import { empty } from 'rxjs/observable/empty';
import { SnackBarComponent } from '@components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material';
import { SearchService } from '@services/search.service';

@Injectable()
export class TrackResolve implements Resolve<any> {
  constructor(
    private accountService: AccountService,
    public store: Store<AppState>,
    private router: Router,
    private matSnackBar: MatSnackBar,
    private searchService: SearchService
  ) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.accountService.getShipmentConsignmentByKey(route.paramMap.get('id'))
      .catch(() => {
        this.router.navigate(['dashboard']);
        this.matSnackBar.openFromComponent(SnackBarComponent, {
          data: {
            error: true,
            message: 'Not correct consignment number'
          },
          panelClass: 'snackbar-container',
          duration: 3000,
        });
        this.searchService.resetSearchField.next(true);
        return empty();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/track.resolve.ts